import type { PayrollProvider, PayrollSharingIntegration, PayrollSharingStatus } from './payroll-sharing.models';

export interface ActivePayrollProvider {
  provider: PayrollProvider;
  name: string;
  mappingLink: string[];
}

const PAYROLL_PROVIDERS: Record<PayrollProvider, { name: string; routeSlug: string }> = {
  nmbrs: { name: 'Nmbrs', routeSlug: 'nmbrs' },
  loket: { name: 'Loket', routeSlug: 'loketv2' },
};

interface KnownPayrollIntegration extends PayrollSharingIntegration {
  provider: PayrollProvider;
}

export function activePayrollProviders(status: PayrollSharingStatus | undefined): ActivePayrollProvider[] {
  if (!status) {
    return [];
  }

  return status.integrations.filter(isKnownIntegration).map((integration) => ({
    provider: integration.provider,
    name: PAYROLL_PROVIDERS[integration.provider].name,
    mappingLink: mappingLink(integration),
  }));
}

export function hasActivePayrollIntegration(status: PayrollSharingStatus | undefined): boolean {
  return activePayrollProviders(status).length > 0;
}

export function payrollSharingActive(status: PayrollSharingStatus | undefined): boolean {
  return !!status?.enabled && hasActivePayrollIntegration(status);
}

function isKnownIntegration(integration: PayrollSharingIntegration): integration is KnownPayrollIntegration {
  return integration.provider in PAYROLL_PROVIDERS;
}

// A provider with exactly one mapping links straight to it; with several, the user
// picks one on the integration page instead.
function mappingLink(integration: KnownPayrollIntegration): string[] {
  const { routeSlug } = PAYROLL_PROVIDERS[integration.provider];
  const [onlyIntegrationId] = integration.integration_ids;

  if (integration.integration_ids.length !== 1) {
    return ['/account', 'integrations', routeSlug];
  }

  return ['/account', 'integrations', routeSlug, 'mapping', String(onlyIntegrationId), 'contract-department'];
}
